import { render, staticRenderFns } from "./ItemTabAttachments.vue?vue&type=template&id=b6ccb046&scoped=true"
import script from "./ItemTabAttachments.vue?vue&type=script&lang=ts"
export * from "./ItemTabAttachments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ccb046",
  null
  
)

export default component.exports